export default "__VITE_ASSET__DWWtIdb4__"